import React, {useState, useEffect} from 'react';
import axios from 'axios';

import AdminHeader from '../../components/AdminHeader.js';

//Subpage imports
import Events from '../admin/Events.js';
import Participants from '../admin/Participants.js';
import ExpiredEvents from '../admin/ExpiredEvents.js';
import TeamOutput from '../admin/TeamOutput.js';
import Account from '../Account.js';

import '../../styles/home/FacilitatorHome.css';

const API_ROUTE = process.env.REACT_APP_API_URL;

function FacilitatorHome() {
  const [pageNumber, setPageNumber] = useState(0);
  const [eventLive, setEventLive] = useState(null);
  const [expiredEventCount, setExpiredEventCount] = useState(0);

  useEffect(() => {
    axios.get(`${API_ROUTE}/event/all_expired`, {
      withCredentials: true
    }).then((res) => {
      setExpiredEventCount(res.data.events.length);
    }).catch((err) => {
      console.log(err);
    });
  }, [pageNumber]);

  //Handle input functions
  const setEventsPage = () => {
    setPageNumber(0);
  }
  const setParticipantsPage = () => {
    setPageNumber(1);
  }
  const setExpiredEventsPage = () => {
    setPageNumber(2);
  }
  const setTeamOutputPage = () => {
    setPageNumber(3);
  }
  const setAccountPage = () => {
    setPageNumber(4);
  }

  const handleReturnToHome = () => {
    setPageNumber(0);
  }

  //Page Rendering
  const renderSubPage = () => {
    switch(pageNumber) {
      case 0:
        return <Events />;
      case 1:
        return <Participants />;
      case 2:
        return <ExpiredEvents isFacilitator={true} />;
      case 3:
        return <TeamOutput />;
      case 4:
        return <Account cbCancel={handleReturnToHome} />;
      default:
        return <div></div>;
    }
  }

  //Load event if facilitator is assigned to one
  useEffect(() => {
    axios.get(`${API_ROUTE}/event/participant_event`, {
      withCredentials: true
    }).then((res) => {
      if (res.data.success) {
        let sessionAccess = res.data.event.sessionAccess;
        setEventLive(sessionAccess=="Live");
      }
    }).catch((err) => {
      console.log(err);
    });
  }, []);

  return (
    <>
      <AdminHeader  eventLive={eventLive}
                    expiredEventCount={expiredEventCount}
                    selected={pageNumber}
                    cbEvents={setEventsPage}
                    cbParticipants={setParticipantsPage}
                    cbExpiredEvents={setExpiredEventsPage}
                    cbTeamOutput={setTeamOutputPage}
                    cbAccount={setAccountPage} />

      <div className="container-facilitatorhome">
        {renderSubPage()}
      </div>
    </>
  );
}

export default FacilitatorHome;
